// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, no-console */
import getErrorMessage from "../utils/getErrorMessage"

export default function promiseMiddleware() {
  return (next) => (action) => {
    const { promise, type, ...rest } = action

    if (!promise) return next(action)

    const SUCCESS = `${type}_SUCCESS`
    const REQUEST = `${type}_REQUEST`
    const FAILURE = `${type}_FAILURE`
    next({ ...rest, type: REQUEST, original_type: type })
    return promise
      .then((res) => {
        next({ ...rest, res, type: SUCCESS, original_type: type })
        return true // Important to return bool, as call site expects it, eg. `dispatch(load()).then(isSuccess => { ... }`
      })
      .catch((err) => {
        const errorMessage = getErrorMessage(err)
        // Another benefit is being able to log all failures here
        console.error(errorMessage)
        next({
          ...rest,
          error: errorMessage,
          type: FAILURE,
          original_type: type,
          _track: {
            error: err.toString(),
            parsedError: errorMessage,
            unknownError: errorMessage === "unknown error", // see promise.md for query to access logs
          },
        })
        return false // Important to return bool, as call site expects it, eg. `dispatch(load()).then(isSuccess => { ... }`
      })
  }
}
